import React, { useState } from "react";
import * as Style from "./styles";
import { CadastroLead } from "../../templates/CadastroLead";
import { CadastroLeadResumido } from "../../templates/CadastroLeadResumido";
import { LayoutApp } from "../../templates/Layout";
import { Access } from "../../control/access/control-access";

import { Link, useParams, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { useEffect } from "react";
// import useAuth from "../../hooks/useAuth";

export const Cadastro = () => {
  const [loading, setLoading] = useState(true);
  const [register, setRegister] = useState(null);
  const [layout, setLayout] = useState(null);
  const { hash } = useParams();

  useEffect(() => {
    getAccess(hash).then((data) => {
      const result = data?.result;
      if (!result) {
        setLoading(false);
        return;
      }

      setLayout(result);
      const { idconfigproduto, necessitacadastro, url, cadastroresumido } = result.lote.produto;
      const qtdLead = result._count.lead

      if ((idconfigproduto == 2 && necessitacadastro == 0) || (idconfigproduto == 2 && necessitacadastro == 1 && qtdLead > 0)) {
        window.location.href = url;
        return "";
      } else if (necessitacadastro == 0 || (necessitacadastro == 1 && qtdLead > 0)) {
        setRegister(result);
        setLoading(false);
        return "";
      }
      setLoading(false);
    });
  }, []);

  const getAccess = async (hash) => {
    try {
      var resp = await Access.getHash(hash);
      if (resp && resp.status === 200) {
        return resp.data;
      }
    } catch (error) {
      return {};
    }
  };

  return (
    <Style.Container>
      <Style.Loading show={loading.toString()}>
        <Spin
          size="large"
          tip="Bem vindo..."
          spinning={loading}
          style={{ width: "75px", position: "relative", left: "-9px" }}
        >
          <div className="content" />
        </Spin>
      </Style.Loading>
      {!loading &&
        (register ? ( <LayoutApp layoutData={layout} /> ) : layout.lote.produto.cadastroresumido == 0 ? ( <CadastroLead layout={layout} /> ) : ( <CadastroLeadResumido layout={layout} /> ))}
    </Style.Container>
  );
};
